/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_To_OverviewInputs */

const da_common_to_overview = /** @type {(inputs: Common_To_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Til overblikket`)
};

/** @type {(inputs: Common_To_OverviewInputs) => LocalizedString} */
const en_common_to_overview = da_common_to_overview;

/**

* @param {Common_To_OverviewInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const common_to_overview = /** @type {((inputs?: Common_To_OverviewInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_To_OverviewInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_to_overview(inputs)
	return /** @type {LocalizedString} */ ("Til overblikket")
});